var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeraFormSwitchRevert',{attrs:{"name":"allow_player_results","label":_vm.$$t(
        'Prohibit entering match results by players',
        'required_label_results'
      ),"disabled":_vm.isStageFieldDisabled('allow_player_results') || _vm.disabled,"error":_vm.errors.first('allow_player_results'),"tooltip":_vm.$$t(
        'The option is recommended only for BR tournaments with admins overlooking the match results'
      )},model:{value:(_vm.allowPlayerResults),callback:function ($$v) {_vm.allowPlayerResults=$$v},expression:"allowPlayerResults"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }